"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cleanRootText = (text) => {
    return text.replace(/\n\n+/g, '\n\n').trim();
};
exports.cleanParagraphText = (text) => {
    return text.replace(/\s+/g, ' ').trim();
};
//# sourceMappingURL=clean-text.js.map